export default {
    'seat_configuration_1': [
        'seat_configuration_1', 
        'seat_configuration_2', 
        'seat_configuration_3', 
        'seat_configuration_4'
    ]
}